import axios from '../axios';

// API for get user details
export const GetUserData = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user`, payload)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// API for add user details
export const AddUserData = (payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`user`, payload)
        .then((res) => {
          if (res.status === 201) {
            let result = res?.data;
            resolve(result);
          } else {
            reject(res?.data?.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  export const UpdateUserData = (payload) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`user`, payload)
        .then((res) => {
          if (res.status === 200) {
            let result = res?.data;
            resolve(result);
          } else {
            reject(res?.data?.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

export const GetUserkycInitiate = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/user-kyc/initiate`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        if(error.status === 422){
          resolve(error?.data)
        }
        reject(error);
      });
  });
}

export const GetUserkycReInitiate = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/user-kyc/reinitiate`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        if(error.status === 422){
          resolve(error?.data)
        }
        reject(error);
      });
  });
}

export const GetUserkycCallback = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/user-kyc/callback`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const GetUserkycData = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/user-kyc`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const PutUserAadharConsent = () => {
  return new Promise((resolve, reject) => {
    axios
      .put(`user/aadhar-consent`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const GetApaarUrl = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/user-kyc/apaar-signed-url`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

